import { Address } from 'modules/common/types/address'

export const formatAddress = (address: Address | undefined) => {
  return `${address?.street || ''}, ${address?.zipCode || ''} ${
    address?.city || ''
  }`
}
